// Career.js

import React from 'react';
import { Link } from 'react-router-dom';
const SuccessSubmission = () => {
  return (
    <div className="container mt-4">
    <div className="d-flex flex-column vh-100">
  
    <div className="container flex-grow-1">
    <h2 className="text-center mb-4">Success page</h2>
     <p className="text-center mb-4">Submission successful! Thank you!</p>
     <Link to="/home" h5 className="card-title">Go Back</Link>
    </div>
  
  </div>
  </div>
  );
};

export default SuccessSubmission;
